module.exports = __webpack_public_path__ + "img/ctrl-pauli-z-root-dagger-1.61943c76.svg";